import { render, staticRenderFns } from "./RolesCreateEdit.vue?vue&type=template&id=431ee7ae&scoped=true"
import script from "./RolesCreateEdit.vue?vue&type=script&lang=js"
export * from "./RolesCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./RolesCreateEdit.vue?vue&type=style&index=0&id=431ee7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431ee7ae",
  null
  
)

export default component.exports